import { orderBy } from 'firebase/firestore'
import type { Shortlist } from '../../../../../src/types/shortlist'
import { getDocumentRef, getQueryRef } from '../wrappers'

export const getShortlistById = (shortlistId: string) => getDocumentRef<Shortlist>('shortlists', shortlistId)

export const getShortlists = () => getQueryRef<Shortlist>('shortlists', orderBy('updatedAt', 'desc'))
